import { render, staticRenderFns } from "./virtualView.vue?vue&type=template&id=d776f532&scoped=true&"
import script from "./virtualView.vue?vue&type=script&lang=js&"
export * from "./virtualView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d776f532",
  null
  
)

export default component.exports